module.exports = __webpack_public_path__ + "static/media/order.dee93f2b.jpg";